/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { EntityId } from '../types/api/EntityId';
import { SUDataset } from '../types/superuser/dataset/SUDataset';
import { SUDatasetCreateRequest } from '../types/superuser/dataset/SUDatasetCreateRequest';
import { SUDatasetUpdateRequest } from '../types/superuser/dataset/SUDatasetUpdateRequest';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserDatasetApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchDatasets = () => this.api.get<SUDataset[]>(`/administration/dataset`);

  updateDataset = ({ id, data }: { id: EntityId; data: SUDatasetUpdateRequest }) => {
    return this.api.patch<SUDatasetUpdateRequest>(`/administration/dataset/${id}`, data);
  };

  createDataset = ({ data }: { data: SUDatasetCreateRequest }) => {
    return this.api.post<SUDatasetCreateRequest>('/administration/dataset', data);
  };

  deleteDataset = ({ datasetId }: { datasetId: EntityId }) => {
    return this.api.del(`/administration/dataset/${datasetId}`);
  };

  verifyDataset = ({ datasetId }: { datasetId: EntityId }) => {
    return this.api.post(`/administration/dataset/${datasetId}/verify`, {});
  };
}

export const SuperuserDatasetApiService = new SuperuserDatasetApiServiceClass();
